import { combineReducers } from '@reduxjs/toolkit'

import { REDUCER_INDEX } from 'match'

import * as match from './match'

export const actions = {
  ...match.actions,
}

export const epics = [...match.epics]

export const reducer = combineReducers({
  match: match.reducer,
})

export const selectors = {
  match: ({ [REDUCER_INDEX]: state }: { [REDUCER_INDEX]: ReturnType<typeof reducer> }) => state.match,
}

export const registerReducer = (state: Record<string, unknown>) => ({
  ...state,
  [REDUCER_INDEX]: reducer,
})
